/**
 * 診療カテゴリ
 * 解放枠（予約枠）に紐づく診療メニューの種別
 */
export type TreatmentCategory =
  | 'pill'            // ピル
  | 'skin'            // スキン
  | 'wellness_clinic' // ウェルクリ
  | 'aga_care'        // AGAケア
  | 'ed'              // ED
  | 'other';          // その他

/**
 * 診療カテゴリの日本語ラベル
 */
export const TREATMENT_CATEGORY_LABELS: Record<TreatmentCategory, string> = {
  pill: 'ピル',
  skin: 'スキン',
  wellness_clinic: 'ウェルクリ',
  aga_care: 'AGAケア',
  ed: 'ED',
  other: 'その他',
};

/**
 * 診療カテゴリの一覧（表示順）
 * セレクトボックスの選択肢生成などに使用
 */
export const TREATMENT_CATEGORIES: TreatmentCategory[] = [
  'pill',
  'skin',
  'wellness_clinic',
  'aga_care',
  'ed',
  'other',
];
